import * as smartpromise from '@pushrocks/smartpromise';

export { smartpromise };
